<script setup lang="ts">
    import { useOrderStore } from "~/composables/store/order";

    const orderStore = useOrderStore();

    const r$ = orderStore.validation.r$;

    const fulfillment = orderStore.currentOrder.fulfillment;

    const availablePickuppoints = computed(() => {
        return orderStore.options.pickupPoints.map((pickupPoint) => ({
            value: pickupPoint.id,
            title: pickupPoint.label,
            subtitle: cutoffString(pickupPoint.description),
        }));
    });

    const selectedPickuppointDescription = computed(() => {
        if (fulfillment.deliver || fulfillment.data.pickupPoint === undefined) {
            return undefined;
        }

        const description = orderStore.options.pickupPoints.find(
            (item) => item.id === fulfillment.data.pickupPoint,
        )?.description;

        if (description === undefined || description.length === 0) {
            return undefined;
        }

        return description;
    });
</script>
<template>
    <VContainer v-if="!fulfillment.deliver" fluid class="pa-0">
        <shared-labeled-field v-slot="{ ariaLabelledby }" label="Afhaalpunt">
            <VSelect
                v-model="fulfillment.data.pickupPoint"
                class="mb-2"
                hide-details="auto"
                :aria-labelledby="ariaLabelledby"
                :item-props="true"
                :items="availablePickuppoints"
                :loading="orderStore.meta.loadingFulfillment"
                :error-messages="r$.$errors.fulfillment.data.pickupPoint"
                @focusout="r$.$fields.fulfillment.data?.pickupPoint?.$touch"
            />
        </shared-labeled-field>
    </VContainer>
    <VAlert
        v-if="selectedPickuppointDescription !== undefined"
        class="mb-2"
        density="compact"
    >
        {{ selectedPickuppointDescription }}
    </VAlert>
</template>
